/** Radius-geofence bounds shared by the site builder and the site edit panel. */
export const DEFAULT_SITE_GEOFENCE_RADIUS_M = 300;
export const MIN_SITE_GEOFENCE_RADIUS_M = 25;
export const MAX_SITE_GEOFENCE_RADIUS_M = 5000;

/** Welfare-check night window defaults (minutes from local midnight). */
export const DEFAULT_WELFARE_NIGHT_START_MINUTE = 1320;
export const DEFAULT_WELFARE_NIGHT_END_MINUTE = 480;
